import { renderLocationSidebar } from './locationSidebar';

export const USERS_TEMPLATE = `
<div class="flex min-h-screen overflow-hidden">
${renderLocationSidebar('users')}
<main class="ml-64 flex-1 flex flex-col min-w-0 min-h-0 bg-background-light">
<header class="h-24 bg-white border-b border-slate-200 flex items-center justify-between px-8 shrink-0">
  <div>
    <h2 class="text-3xl font-black text-slate-900 tracking-tight">User Management</h2>
    <p class="text-slate-500 text-sm">Manage platform administrators, editors, and users</p>
  </div>
  <a href="/users/create" class="inline-flex items-center justify-center gap-2 bg-primary hover:bg-primary/90 text-white font-bold py-2.5 px-6 rounded-lg transition-all shadow-sm">
    <span class="material-symbols-outlined text-sm">add</span>
    Add User
  </a>
</header>

<div class="flex-1 overflow-y-auto p-8 bg-background-light">
  <div class="bg-white p-4 rounded-xl border border-slate-200 flex flex-col lg:flex-row gap-4 mb-6 shadow-sm">
    <div class="relative flex-1">
      <span class="material-symbols-outlined absolute left-3 top-1/2 -translate-y-1/2 text-slate-400">search</span>
      <input id="users-search-input" class="w-full pl-10 pr-4 py-2 bg-slate-50 border-none rounded-lg text-sm focus:ring-2 focus:ring-primary/20 placeholder:text-slate-400 text-slate-700" placeholder="Search by name or email..." type="text"/>
    </div>

    <div class="flex flex-wrap items-center gap-3">
      <select id="users-status-filter" class="text-sm bg-slate-100 border-none rounded-lg focus:ring-primary py-2 px-3">
        <option value="all">Status: All</option>
        <option value="true">Active</option>
        <option value="false">Inactive</option>
      </select>
      <select id="users-role-filter" class="text-sm bg-slate-100 border-none rounded-lg focus:ring-primary py-2 px-3">
        <option value="all">Role: All</option>
        <option value="admin">Admin</option>
        <option value="editor">Editor</option>
        <option value="user">User</option>
      </select>
      <select id="users-ordering-filter" class="text-sm bg-slate-100 border-none rounded-lg focus:ring-primary py-2 px-3">
        <option value="-date_joined">Newest First</option>
        <option value="date_joined">Oldest First</option>
        <option value="-last_login">Recently Active</option>
        <option value="email">Email A-Z</option>
      </select>
    </div>
  </div>

  <div class="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden">
    <div class="overflow-x-auto">
      <table class="w-full text-left">
        <thead class="bg-slate-50 border-b border-slate-200">
          <tr>
            <th class="px-6 py-4 text-xs font-bold text-slate-500 uppercase tracking-wider">Name</th>
            <th class="px-6 py-4 text-xs font-bold text-slate-500 uppercase tracking-wider">Email</th>
            <th class="px-6 py-4 text-xs font-bold text-slate-500 uppercase tracking-wider">Role</th>
            <th class="px-6 py-4 text-xs font-bold text-slate-500 uppercase tracking-wider">Status</th>
            <th class="px-6 py-4 text-xs font-bold text-slate-500 uppercase tracking-wider">Last Login</th>
            <th class="px-6 py-4 text-xs font-bold text-slate-500 uppercase tracking-wider text-right">Actions</th>
          </tr>
        </thead>
        <tbody id="users-table-body" class="divide-y divide-slate-100">
          <tr><td class="px-6 py-6 text-sm text-slate-500" colspan="6">Loading users...</td></tr>
        </tbody>
      </table>
    </div>

    <div class="bg-slate-50 px-6 py-4 border-t border-slate-100 flex items-center justify-between gap-4">
      <span id="users-table-meta" class="text-xs font-medium text-slate-500">Showing 0 users</span>
      <div class="flex items-center gap-2">
        <button id="users-prev-btn" class="px-3 py-1.5 rounded-lg border border-slate-200 text-slate-600 hover:bg-white text-sm disabled:opacity-50 disabled:cursor-not-allowed" type="button">Prev</button>
        <span id="users-page-indicator" class="text-xs font-semibold text-slate-500 min-w-[72px] text-center">Page 1</span>
        <button id="users-next-btn" class="px-3 py-1.5 rounded-lg border border-slate-200 text-slate-600 hover:bg-white text-sm disabled:opacity-50 disabled:cursor-not-allowed" type="button">Next</button>
        <button id="users-reload-btn" class="px-3 py-1.5 rounded-lg border border-slate-200 text-slate-600 hover:bg-white text-sm" type="button">Reload</button>
      </div>
    </div>
  </div>
</div>

<div id="users-delete-modal" class="fixed inset-0 z-[80] hidden">
  <div id="users-delete-modal-backdrop" class="absolute inset-0 bg-slate-900/40"></div>
  <div class="absolute inset-0 flex items-center justify-center p-4">
    <div class="w-full max-w-md rounded-xl bg-white border border-slate-200 shadow-xl p-6">
      <h3 class="text-lg font-bold text-slate-900">Delete User</h3>
      <p class="mt-2 text-sm text-slate-600">Delete this user? This action cannot be undone.</p>
      <div class="mt-6 flex items-center justify-end gap-3">
        <button id="users-delete-modal-cancel" class="px-4 py-2 rounded-lg border border-slate-200 text-slate-700 font-semibold hover:bg-slate-50" type="button">Cancel</button>
        <button id="users-delete-modal-confirm" class="px-4 py-2 rounded-lg bg-rose-600 text-white font-semibold hover:bg-rose-700" type="button">Delete</button>
      </div>
    </div>
  </div>
</div>
</main>
</div>
`;
